import { render, staticRenderFns } from "./GenericCrud.vue?vue&type=template&id=c58b5256&scoped=true&"
import script from "./GenericCrud.vue?vue&type=script&lang=js&"
export * from "./GenericCrud.vue?vue&type=script&lang=js&"
import style0 from "./GenericCrud.vue?vue&type=style&index=0&id=c58b5256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b5256",
  null
  
)

export default component.exports